// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__36RvV","right":"Footer_right__2k5oA","buttons":"Footer_buttons__N7zRg"};